import { GET_INVOICE } from './getInvoice';
import { UPDATE_INVOICE } from './updateInvoice';
import { APPLY_CHARGES } from './applyCharges';

export const invoiceApi = {
  getByID: GET_INVOICE,
  update: UPDATE_INVOICE,
  applyCharges: APPLY_CHARGES,
};
